<template>
  <footer class="legal-footer text-muted" :class="IsDashboard ? '' : 'text-center'" :style="{'color' : ColorText ? ColorText : ''}">
    Copyright © C.S.G. S.r.l. - Centro Servizi di Geoingegneria S.r.l. -
    All rights Reserved | 
    <a 
      href="https://www.iubenda.com/privacy-policy/45686424"
      target="_blank"
      rel="noopener noreferrer"
      class="privacy-link"
      :style="{ 'color': isInvisibleColor ? 'transparent' : '#F18B53' }"
    >Privacy Policy</a>
    Ricaldone (AL) - ITALY -
    P.I. 01744460062
  </footer>
</template>

<script >
export default 
{
  data() 
  {
    return {
    };
  },

  props: ['IsDashboard', 'ColorText'],

  methods:
  {
  },

  computed: {
    isInvisibleColor() 
    {
      if (!this.ColorText) return false;
      const Text = this.ColorText.trim();
      const LastChar = Text.charAt(Text.length - 2);
      return LastChar == '0';
    }
  }
}
</script>

<style scoped>
.legal-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  font-size: 10px;
  padding: 8px;
  color: black;
}
.privacy-link {
  font-weight: bold;
  text-decoration: underline;
  color: #F18B53;
  white-space: nowrap; 
}
</style>